var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MdBtn",class:_vm.btnClass},[_c('a',{style:(_vm.btnStyle)},[_c('div',[_vm._v(_vm._s(this.data.action.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }